import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  progress: {
    height: "100%",
    backgroundColor: "#055007",
  },
  bar: {
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    transitionDuration: "1s",
    backgroundColor: theme.palette.events.successDark,
  },
  progressStop: {
    backgroundColor: "#ea0000",
  },
  barStop: {
    backgroundColor: theme.palette.events.errorDark,
  },
  progressLow: {
    backgroundColor: "#403700",
  },
  barLow: {
    backgroundColor: "#ffdb0a",
  },
  remainingTimeWrapper: {
    display: "flex",
    position: "absolute",
    top: 2,
    color: "white",
    right: 10,
  },
  roundsCount: {
    paddingRight: 5,
  },
}));
